import type { LayoutItem } from 'react-grid-layout';

/** Размер виджета по умолчанию и пределы ресайза в клетках сетки дашборда */
export type WidgetSize = Omit<LayoutItem, 'i' | 'x' | 'y'>;

export const calendarWidgetSize: WidgetSize = { w: Infinity, h: 16, minW: 20, maxW: 40, minH: 16, maxH: 30 };
export const favoritesWidgetSize: WidgetSize = { w: 20, h: 10, minW: 20, maxW: 40, minH: 10, maxH: 15 };
export const draftsWidgetSize: WidgetSize = { w: 20, h: 10, minW: 20, maxW: 40, minH: 10, maxH: 15 };
export const textWidgetSize: WidgetSize = { w: 10, h: 6, minW: 7, maxW: 13, minH: 3, maxH: 9 };

/**
 * Размеры по builderClassId: store раскладывает новый виджет, не загружая
 * билдеры с их компонентами.
 */
export const widgetSizes: Record<string, WidgetSize> = {
    'calendar-widget': calendarWidgetSize,
    'favorites-widget': favoritesWidgetSize,
    'drafts-widget': draftsWidgetSize,
    'text-widget': textWidgetSize,
};
